/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import { useState } from "react";
import {service as ContactService} from "../Services/ContactService";
import {useEffectPromise} from "./EffectHooks";

export const useFetchContact = (stakeholderId = null, bootstrappedContact = null) => {
	const [contactModel, setContactModel] = useState(null);

	// factors that affect reloading
	const expectedStakeholderId = bootstrappedContact?.stakeholderId ?? stakeholderId;
	const contactModelDoesntMatchStakeholderIdProp = (contactModel == null) || (Number(contactModel.stakeholderId) !== Number(expectedStakeholderId));
	
	// conditions upon which we should reload the Contact
	const shouldFetchModel = (
		expectedStakeholderId && // there is something to fetch
		( !(contactModel ?? bootstrappedContact) || contactModelDoesntMatchStakeholderIdProp) // the contactProp changed
	);
	
	useEffectPromise(
		async () => (await ContactService.Get(expectedStakeholderId))?.result,
		setContactModel,
		[shouldFetchModel, expectedStakeholderId],
		shouldFetchModel
	);

	return contactModel ?? bootstrappedContact;
};
